module.exports = __webpack_public_path__ + "img/pic3.916850a5.png";